// extracted by mini-css-extract-plugin
export default {"emptySection":"styles_emptySection__b6SV+","icon":"styles_icon__wtL4g","heading":"styles_heading__L6VIb","para":"styles_para__SW7BY"};